(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["sesh-first-order-promo"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click',function(e){var b=e.target.closest('[data-sfo-copy]');if(!b)return;if(!navigator.clipboard||!navigator.clipboard.writeText)return;navigator.clipboard.writeText('First-order').then(function(){var old=b.textContent;b.textContent=b.dataset.sfoSuccess||old;setTimeout(function(){b.textContent=old},1400)}).catch(function(){});});
  } catch(e) { console.error(e); }
})();

})();
